if (customElements && !customElements.get('timer-countdown')) {
  class TimerCountdown extends HTMLElement {
    constructor() {
      super();
      this.endDate = null;
      this.intervalId = null;

      this.daysEl = this.querySelector('.js-timer-days');
      this.hoursEl = this.querySelector('.js-timer-hours');
      this.minutesEl = this.querySelector('.js-timer-minutes');
      this.secondsEl = this.querySelector('.js-timer-seconds');
      this.displayEl = this.querySelector('.js-timer-display');
      this.expiredEl = this.querySelector('.js-timer-expired');
    }

    connectedCallback() {
      const endDateStr = this.dataset.endDate;
      if (!endDateStr) {
        console.error('No end date provided for countdown timer');
        return;
      }

      this.endDate = new Date(endDateStr).getTime();

      if (isNaN(this.endDate)) {
        console.error('Invalid end date format');
        return;
      }

      this.updateCountdown();
      this.intervalId = setInterval(() => this.updateCountdown(), 1000);
    }

    disconnectedCallback() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
    }

    updateCountdown() {
      const now = new Date().getTime();
      const distance = this.endDate - now;

      if (distance < 0) {
        this.handleExpired();
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      this.daysEl.textContent = this.padZero(days);
      this.hoursEl.textContent = this.padZero(hours);
      this.minutesEl.textContent = this.padZero(minutes);
      this.secondsEl.textContent = this.padZero(seconds);
    }

    padZero(num) {
      return num.toString().padStart(2, '0');
    }

    handleExpired() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }

      if (this.displayEl) {
        this.displayEl.style.display = 'none';
      }

      if (this.expiredEl) {
        this.expiredEl.style.display = 'block';
      }
    }
  }

  customElements.define('timer-countdown', TimerCountdown);
}
